<app-hierarchy-filter (applied)="onFiltersApplied()" (cleared)="onFiltersCleared()"></app-hierarchy-filter>

<div class="updated-dashboard-wrapper">

    <!-- TOP HEADER / FILTER BAR -->
    <header class="ud-top-bar" *ngIf="false">

        <!-- Center Filters & Rural/Urban -->
        <div class="ud-filters-group">
            <div class="ud-filter-item">
                <label class="ud-filter-label">{{ langService.currentLang === 'mr' ? 'आर्थिक वर्ष' : 'Financial Year'
                    }}</label>
                <dx-select-box [items]="YearsList" [(value)]="FinancialYearRef" displayExpr="p.short_name"
                    valueExpr="p.id" [placeholder]="CurrentFinancialYear || '2026-2027'"
                    (onValueChanged)="onYearChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <div class="ud-filter-item">
                <label class="ud-filter-label">{{ langService.currentLang === 'mr' ? 'फिल्टर प्रकार' : 'Filter Type'
                    }}</label>
                <dx-select-box [items]="FilterList" [(value)]="ReportFilterType" [displayExpr]="getTranslatedName"
                    valueExpr="Ref" placeholder="{{ 'REPORT_PLACEHOLDERS.Select' | translate }}"
                    (onValueChanged)="OnFilterChange($event.value)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Half Year (Conditional) -->
            <div class="ud-filter-item" *ngIf="IsShowHalfYear">
                <label class="ud-filter-label">{{ 'FILTER_LABELS.HalfYear' | translate }}</label>
                <dx-select-box [items]="HalfYearList" [(value)]="HalfYearType" [displayExpr]="getTranslatedName"
                    valueExpr="Ref" [placeholder]="'REPORT_PLACEHOLDERS.SelectHalfYear' | translate"
                    (onValueChanged)="onHalfYearChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Quarter (Conditional) -->
            <div class="ud-filter-item" *ngIf="IsShowQuarter">
                <label class="ud-filter-label">{{ 'FILTER_LABELS.Quarter' | translate }}</label>
                <dx-select-box [items]="QuarterList" [(value)]="QuarterlyYearType" [displayExpr]="getTranslatedName"
                    valueExpr="Ref" [placeholder]="'REPORT_PLACEHOLDERS.SelectQuarter' | translate"
                    (onValueChanged)="onQuarterChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Month (Conditional) -->
            <div class="ud-filter-item" *ngIf="IsShowMonth">
                <label class="ud-filter-label">{{ 'FILTER_LABELS.Month' | translate }}</label>
                <dx-select-box [items]="MonthList" [(value)]="Month" [displayExpr]="getTranslatedName" valueExpr="Ref"
                    [placeholder]="'REPORT_PLACEHOLDERS.SelectMonth' | translate"
                    (onValueChanged)="onMonthChanged($event)" [searchEnabled]="true" class="ud-select-box">
                </dx-select-box>
            </div>

            <!-- Rural / Urban Toggle Switch -->
            <div class="ud-area-toggle-wrap">
                <div class="ud-area-toggle">
                    <button type="button" class="ud-area-btn" [class.active]="selectedArea === 'rural'"
                        (click)="onAreaChange('rural')">
                        {{ langService.currentLang === 'mr' ? 'ग्रामीण' : 'Rural' }}
                    </button>
                    <button type="button" class="ud-area-btn" [class.active]="selectedArea === 'urban'"
                        (click)="onAreaChange('urban')">
                        {{ langService.currentLang === 'mr' ? 'शहरी' : 'Urban' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Right Profile & Hierarchy Filter Button -->
        <div class="ud-user-section">
            <button type="button" class="ud-funnel-btn" (click)="openFilterPanel()"
                [title]="langService.currentLang === 'mr' ? 'फिल्टर उघडा' : 'Open Filters'">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="#d82b6b">
                    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                </svg>
            </button>
        </div>
    </header>

    <!-- EMPTY STATE FOR URBAN -->
    <div *ngIf="isUrbanNoData" class="ud-empty-urban">
        <div class="ud-empty-card">
            <span class="ud-empty-icon">📊</span>
            <h3>{{ langService.currentLang === 'mr' ? 'शहरी क्षेत्रासाठी कोणतीही माहिती उपलब्ध नाही' : 'No data
                available for Urban area' }}</h3>
            <p>{{ langService.currentLang === 'mr' ? 'कृपया ग्रामीण क्षेत्र निवडा' : 'Please select Rural area to view
                dashboard records' }}</p>
            <button class="ud-back-rural-btn" (click)="onAreaChange('rural')">{{ langService.currentLang === 'mr' ?
                'ग्रामीण क्षेत्रावर जा' : 'Switch to Rural' }}</button>
        </div>
    </div>

    <ng-container *ngIf="!isUrbanNoData">

        <!-- ALL TASKS - TODAY (same card as dashboard Today's Task) -->
        <section class="ud-section ud-today-tasks-section">
            <div class="ud-tasks-header">
                <div class="ud-tasks-header-left">
                    <button type="button" class="ud-back-circle-btn" (click)="BackAsha()"
                        [title]="langService.currentLang === 'mr' ? 'मागे' : 'Back'">
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <h3 class="ud-section-title">
                        {{ langService.currentLang === 'mr' ? 'सर्व कामे – आज' : 'All Tasks – Today' }}
                    </h3>
                    <span class="ud-tasks-total-badge" *ngIf="todayTasks && todayTasks.length > 0">
                        {{ totalTodayTasksCount }}
                    </span>
                </div>
            </div>

            <div class="ud-task-card">
                <!-- Loader State -->
                <!-- <div class="ud-tasks-loader-state" *ngIf="isLoading">
                    <div class="ud-spinner"></div>
                    <p class="ud-tasks-loader-text">{{ langService.currentLang === 'mr' ? 'माहिती लोड होत आहे...' : 'Loading tasks...' }}</p>
                </div> -->

                <!-- Task rows when tasks exist -->
                <ng-container *ngIf="!isLoading">
                    <ng-container *ngIf="todayTasks && todayTasks.length > 0; else emptyTasksTemplate">
                        <div class="ud-task-row" *ngFor="let task of todayTasks; let last = last"
                            [class.border-dotted]="!last">
                            <div class="ud-task-info">
                                <div class="ud-task-icon-circle">
                                    <img *ngIf="task.iconImg" [src]="task.iconImg" [alt]="task.title">
                                    <span *ngIf="!task.iconImg" class="ud-task-emoji">{{ task.emoji }}</span>
                                </div>
                                <span class="ud-task-name">
                                    {{ langService.currentLang === 'mr' ? task.titleMr : task.title }}
                                </span>
                            </div>

                            <div class="ud-task-count-wrap">
                                <span class="ud-task-count">{{ task.count }}</span>
                            </div>

                            <div class="ud-task-action-wrap">
                                <button type="button" class="ud-view-btn" (click)="onTaskClick(task.id)">
                                    <span>{{ langService.currentLang === 'mr' ? 'तपशील पहा' : 'View Details' }}</span>
                                    <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor"
                                        stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Empty state when no tasks -->
                <ng-template #emptyTasksTemplate>
                    <div class="ud-tasks-empty-state">
                        <div class="ud-tasks-empty-icon-wrap">
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#E83E6C"
                                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="4" width="18" height="18" rx="3" ry="3"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                                <path d="m9 16 2 2 4-4"></path>
                            </svg>
                        </div>
                        <h4 class="ud-tasks-empty-title">
                            {{ langService.currentLang === 'mr' ? 'आज कोणतेही काम नाही' : 'No tasks for today' }}
                        </h4>
                        <p class="ud-tasks-empty-subtitle">
                            {{ langService.currentLang === 'mr' ? 'सर्व कामे पूर्ण झाली आहेत.' : "You're all caught up."
                            }}
                        </p>
                    </div>
                </ng-template>
            </div>
        </section>
    </ng-container>
</div>